import React, { useState } from "react";

const SingleFaq = ({ item, isOpen, onToggle }) => {
  const { title, desc, id, show } = item || {};
  const [internalOpen, setInternalOpen] = useState(Boolean(show));
  const controlled = typeof isOpen === "boolean";
  const expanded = controlled ? isOpen : internalOpen;
  const handleToggle = () => {
    if (onToggle) {
      onToggle();
    } else {
      setInternalOpen((current) => !current);
    }
  };

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={`heading${id}`}>
        <button
          className={`accordion-button ${expanded ? "" : "collapsed"}`}
          type="button"
          aria-expanded={expanded ? "true" : "false"}
          aria-controls={`collapse${id}`}
          onClick={handleToggle}
        >
          {title}
          <span className="accordion-btn"></span>
        </button>
      </h2>
      <div
        id={`collapse${id}`}
        className={`accordion-collapse collapse ${expanded ? "show" : ""}`}
        aria-labelledby={`heading${id}`}
      >
        <div className="accordion-body">
          <p>{desc}</p>
        </div>
      </div>
    </div>
  );
};

export default SingleFaq;
